import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { Card, Table, Accordion, Spinner } from "react-bootstrap";
import {
  checkExamFormFilled,
  fillForm,
  getStudentDetails,
} from "../../store/actions/homeActions/homeActions";
import { updatePaymentStatus } from "../../store/actions/centerActions/payment";
import { ALERT } from "../../store/actions/actionTypes";

const ExamForm = () => {
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [roll_number, setroll_number] = useState("");
  const[exam_mode,setExam_mode]=useState("")
  const [filled, setFilled] = useState(false);
  const [dob, setDob] = useState("");
  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const [semester, setSemester] = useState("");
  const [userSubjects, setUserSubject] = useState(null);
  const [payingNow, setPayingNow] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null); // null | 'success' | 'failed'
  // Exam fee comes from the course fee the ADMIN maintains (fee.exam_fee),
  // eager-loaded as course.Fee by exam-form-data. It was previously a
  // hard-coded placeholder of 10.
  const EXAM_FORM_FEE = Number(data?.course?.fee?.exam_fee) || 0;

  // Course-wise and subject-wise courses are paid for at registration, so
  // their students fill the exam form without paying anything. Semester and
  // yearly courses pay the exam fee on submit.
  const noFeeCourse =
    data?.course?.exam_type == "course_wise" ||
    data?.course?.exam_type == "subject_wise";

  const convertArrayToObject = (array, key) => {
    const hs = new Map();
    array.map((element) => {
      if (hs.get(element.semester)) {
        hs.set(element.semester, [...hs.get(element.semester), element]);
      } else {
        hs.set(element.semester, [element]);
      }
    });
    return Object.fromEntries(hs);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setData(null);
    setSemester("");
    const response = await dispatch(
      getStudentDetails({
        roll_number: roll_number,
        dob: dob,
      })
    );
    if (response) {
      setData(response[0] || false);
      setLoading(false);
    } else {
      setData(false);
      setLoading(false);
    }
  };
  useEffect(async () => {
    if (!data) return;

    // A course-wise course has no semester, so the check is by course alone.
    if (!noFeeCourse && !semester) return;

    setChecking(true);
    const response = await dispatch(
      checkExamFormFilled({
        student_id: data.id,
        course_id: data.course.id,
        semester: noFeeCourse ? "" : semester,
      })
    );
    setChecking(false);
    setFilled(!!response);

    if (response) {
      dispatch({
        type: ALERT,
        payload: {
          error: noFeeCourse
            ? "You have already filled the examination form for this course."
            : `You already have filled exam form for ${
                data.course.course_type == "2" ? "Semester" : "Year"
              } ${semester}`,
        },
      });
    }
  }, [data, semester]);
  const fillExamForm = async (razorpayResponse) => {
    const response = await dispatch(
      fillForm({
        student_id: data.id,
        course_id: data.course.id,
        // a course-wise course has neither of these
        samster_id: semester || null,
        exam_mode: exam_mode === "" ? 0 : exam_mode,
        razorpay_payment_id: razorpayResponse?.razorpay_payment_id,
        razorpay_order_id: razorpayResponse?.razorpay_order_id,
      })
    );
    if (response) {
      setroll_number("");
      setDob("");
      setData(null);
      setSemester("");
      setFilled(true);
    }
    return response;
  };

  // No money changes hands for a course-wise or subject-wise course, so the
  // form is submitted straight away without opening Checkout.
  const handleSubmitWithoutFee = async () => {
    setPayingNow(true);
    const response = await fillExamForm();
    setPayingNow(false);
    if (response) setPaymentStatus("submitted");
  };

  const handlePayAndSubmitExamForm = async () => {
    // Never open Checkout without a real amount - that would charge nothing
    // and still submit the form.
    if (!EXAM_FORM_FEE) {
      alert(
        "Exam fee is not configured for this course. Please contact the council."
      );
      return;
    }

    setPayingNow(true);
    setPaymentStatus(null);

    const loaded = await new Promise((resolve) => {
      if (window.Razorpay) return resolve(true);
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

    if (!loaded) {
      alert("Razorpay SDK failed to load. Check your internet connection.");
      setPayingNow(false);
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      amount: EXAM_FORM_FEE * 100, // paise
      currency: "INR",
      name: process.env.REACT_APP_META_NAME || "NSVEC",
      description: `Exam Form Fee | ${data.name}`,
      handler: async (razorpayResponse) => {
        const response = await fillExamForm(razorpayResponse);

        // Record the exam-form payment so the money is traceable. Previously
        // razorpay_payment_id was posted to the exam-form endpoint, which
        // ignored it entirely - the exam_form table has no payment columns -
        // so these payments left no record anywhere.
        // update_fee_status=0: fee_status tracks the REGISTRATION fee, and an
        // exam-form payment must not mark registration as paid.
        if (response && razorpayResponse?.razorpay_payment_id) {
          const feeData = new FormData();
          feeData.append(
            "razorpay_payment_id",
            razorpayResponse.razorpay_payment_id
          );
          feeData.append("student_id", data.id);
          feeData.append("semester", semester || "1");
          feeData.append("amount", EXAM_FORM_FEE);
          feeData.append("exam_fee", EXAM_FORM_FEE);
          feeData.append("registration_fee", "0");
          // paid by the student themselves on the public exam form
          feeData.append("deposited_by", "student");
          feeData.append("update_fee_status", "0");
          await dispatch(updatePaymentStatus(feeData));
        }

        setPaymentStatus(response ? "success" : "failed");
        setPayingNow(false);
      },
      prefill: { name: data.name, contact: data.mobile || "9999999999" },
      theme: { color: "#3399cc" },
      modal: { ondismiss: () => setPayingNow(false) },
    };

    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", () => {
      setPaymentStatus("failed");
      setPayingNow(false);
    });
    rzp.open();
  };
  return (
    <div className="gallery-box">
      <div className="container">
        <div className="title-box">
          <div className="col-md-12 inner">
            <section className="innerbanner">
              <ol className="breadcrumb">
                <li>
                  <Link to="/" className="none">
                    Home
                  </Link>
                </li>
                <li> / </li>
                <li className="active"> Examination Form</li>
              </ol>
            </section>
            <div className="col-lg-12">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-5">
                    <div className="row d-flex">
                      <label className="col-md-3">Roll No.</label>
                      <input
                        className="col-md-8"
                        placeholder="Enter Roll No"
                        value={roll_number}
                        onChange={(e) => setroll_number(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-5">
                    <div className="row">
                      <label className="col-md-3">DOB</label>
                      <input
                        className="col-md-8"
                        type="date"
                        placeholder="Enter DOB"
                        value={dob}
                        onChange={(e) => setDob(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="float-center ">
                      <input
                        type={"submit"}
                        value="Search"
                        className="btn-success btn-lg btn"
                      />
                    </div>
                  </div>
                </div>
              </form>

              {data === false && <h3>No record found</h3>}
              {data && (
                <div className="row justify-content-center mt-3">
                  <div className="col-md-8 ">
                    <div className="card">
                      <div className="card-header text-center">
                        Fill Exam Form
                      </div>
                      <div className="card-body">
                        <div className="row exam-form">
                          <table className="w-100 table">
                            <tbody>
                              <tr>
                                <td className="w-50">Student Name</td>
                                <td className="w-50">{data.name}</td>
                              </tr>
                              <tr>
                                <td>Roll No.</td>
                                <td>{data.roll_number}</td>
                              </tr>
                              <tr>
                                <td>DOB</td>
                                <td>{moment(data.dob).format("DD/MM/YYYY")}</td>
                              </tr>
                              <tr>
                                <td>Course</td>
                                <td>{data.course.name}</td>
                              </tr>
                              {noFeeCourse && (
                                <tr>
                                  <td>Examination Fee</td>
                                  <td>
                                    No fee for this course - it was paid at
                                    registration
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="form-group">
                          {data.course.exam_type == "course_wise" ||
                          data.course.exam_type == "subject_wise" ? null : (
                            <>
                              <label>Exam Mode</label>
                              <select
                                className="form-control"
                                value={exam_mode}
                                onChange={(e) => setExam_mode(e.target.value)}
                                required
                              >
                                <option value="">--Select--</option>
                               <option value={0}>Online</option><option value={1}>Offline</option>
                              </select>
                            </>
                          )}
                          </div>
                        <div className="form-group">
                          {data.course.exam_type == "course_wise" ||
                          data.course.exam_type == "subject_wise" ? null : (
                            <>
                              <label>Select Semester</label>
                              <select
                                className="form-control"
                                value={semester}
                                onChange={(e) => setSemester(e.target.value)}
                                required
                              >
                                <option value="">--Select--</option>
                                {Object.keys(
                                  convertArrayToObject(data.course.subject)
                                ).map((element) => (
                                  <option value={element}>{element}</option>
                                ))}
                              </select>
                            </>
                          )}
                          {data.course.exam_type != "course_wise" &&
                            data.course.exam_type != "subject_wise" &&
                            (checking ? (
                              <Spinner
                                animation="border"
                                role="status"
                                size="lg"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </Spinner>
                            ) : filled ? null : !semester ? null : (
                              <button
                                onClick={handlePayAndSubmitExamForm}
                                disabled={payingNow}
                                className="btn btn-success mt-4 float-right"
                              >
                                Pay & Submit Exam Form
                              </button>
                            ))}

                          {noFeeCourse &&
                            (checking ? (
                              <Spinner animation="border" role="status" size="lg">
                                <span className="visually-hidden">Loading...</span>
                              </Spinner>
                            ) : filled ? null : (
                              <button
                                onClick={handleSubmitWithoutFee}
                                disabled={payingNow}
                                className="btn btn-success mt-4 float-right"
                              >
                                Submit Exam Form
                              </button>
                            ))}
                        </div>
                        {paymentStatus === "submitted" && (
                          <div className="alert alert-success mt-3">
                            <strong>Exam form submitted.</strong> No fee is
                            payable for this course.
                          </div>
                        )}
                        {paymentStatus === "success" && (
                          <div className="alert alert-success mt-3">
                            <strong>Payment Successful!</strong> Exam form submitted.
                          </div>
                        )}
                        {paymentStatus === "failed" && (
                          <div className="alert alert-danger mt-3">
                            <strong>Payment Failed.</strong> Please try again.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {loading && (
                <div className="text-center">
                  <Spinner animation="border" role="status" size="lg">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamForm;
